import * as React from "react";

import { AppContext } from "@1js/acui-context";
import { MeasuredContext } from "@fluentui/react";
import { shouldPersistMenu } from "../../shouldPersistMenu";
import { shouldShadowRender } from "@1js/acui-shadow-rendering";
import { RibbonSplitButtonProps } from "./RibbonSplitButton.types";

// eslint-disable-next-line no-restricted-imports
import { useAppSplitButton } from "@1js/acui-button/lib/Next";
import { RibbonSplitButtonPrimaryButton } from "./RibbonSplitButtonPrimaryButton";
import { RibbonSplitButtonMenuButton } from "./RibbonSplitButtonMenuButton";
import { RibbonSplitButtonPrimaryToggleButton } from "./RibbonSplitButtonPrimaryToggleButton";

export const useRibbonSplitButton = (
  props: RibbonSplitButtonProps,
  ref: React.Ref<HTMLButtonElement>
) => {
  const { menuDefinition, shadowRenderMenu, dataAutomationType } = props;

  // Getting context and app settings to enable/disable shadow rendering
  const appContext = React.useContext(AppContext);
  const measuredContext = React.useContext(MeasuredContext);

  const state = useAppSplitButton(
    {
      ...props,
      dataAutomationType: dataAutomationType ?? "RibbonSplitButton",
      persistMenu: shouldPersistMenu(appContext, menuDefinition),
      preventCalloutDismissOnScroll: true,
      shadowRenderMenu: shouldShadowRender(
        shadowRenderMenu,
        appContext,
        measuredContext.isMeasured
      ),
    },
    ref
  );

  // We want to render the corresponding Ribbon components instead of App components
  if (state.components) {
    state.components.primaryActionButton = props.toggleable
      ? RibbonSplitButtonPrimaryToggleButton
      : RibbonSplitButtonPrimaryButton;
    state.components.menuButton = RibbonSplitButtonMenuButton;
  }

  return state;
};
